import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  BackendIcon,
  CPAppIcon,
} from "../../../../app-constants";

const StackItem = [
  {
    icon: IphoneIcon,
    title: "Mobile Frontend",
    description: "React, TypeScript,  JavaScript, Bootstrap",
  },
  {
    icon: AndroidIcon,
    title: "Databases",
    description: "SQLite, Firebase, Pounchdb,  Realm, AWS, azure-full",
  },
  {
    icon: CPAppIcon,
    title: "React Native Specific Tools",
    description:
      "Expo, React Navigation,  Redux Pertsist, Reduxsauce,  Reactotron",
  },
  {
    icon: BackendIcon,
    title: "Backend Integration Tools",
    description: "Rest Api, GraphQL, Apollo GraphQL",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>
                Technologies We Use for React Native Application Development in
                UK
              </h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              As a globally recognized React Native app development company in
              UK, we use a wide range of the latest technologies to meet your
              distinctive requirements. React Native as one of the popular
              frameworks has the ability to develop cross-platform apps with
              native performance. React Native is a JavaScript library that
              combines the speed of JavaScript & uses a new approach to
              rendering mobile apps, resulting in exceptionally dynamic and
              responsiveness to user interactions. Our React Native app
              development services are supported by exceptional coding standards
              and a dedicated focus on UI/UX principles.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
